// Order here controls the popup and trigger marks. Optional logos: assets/agents/<id>.svg.
// A product's directory URL takes priority over copying its MCP setup prompt.
export const agentAssistants = Object.freeze([
  {
    id: 'claude',
    name: 'Claude',
    directoryUrls: {
      signitic: 'https://claude.ai/directory/signitic',
      surfer: 'https://claude.ai/directory/positive-surfer',
      iconosquare: 'https://claude.ai/directory/iconosquare-social-media-management',
    },
  },
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    directoryUrls: {
      signitic: 'https://chatgpt.com/plugins/plugin_asdk_app_6ae36c1c93bc8191bf5113f2f5729923',
      surfer: 'https://chatgpt.com/plugins/plugin_asdk_app_6ac4ec4eec288191b37184706855fbc4',
    },
  },
  {
    id: 'other',
    name: 'Other',
    nameKey: 'agent.other',
    examples: 'Cursor, VS Code, Mistral…',
    logoIds: Object.freeze(['cursor', 'vscode', 'mistral']),
    directoryUrls: {},
  },
].map((assistant) => Object.freeze({ ...assistant, directoryUrls: Object.freeze(assistant.directoryUrls) })));

// Fallback for assistants without a directory URL. null/empty disables copying.
export const agentMcpUrls = Object.freeze({
  signitic: 'https://mcp.signitic.com/mcp',
  user: null,
  surfer: 'https://mcp.surferseo.com/mcp',
  iconosquare: 'https://api.iconosquare.com/mcp',
  humanlinker: null,
  ubic: null,
  nocrm: null,
  '4dem': null,
  mailingwork: null,
  rapidmail: null,
  sarbacane: null,
});

// Optional client-specific context for the generic MCP setup prompt.
export const agentSetupGuideUrls = Object.freeze({
  surfer: 'https://devs.surferseo.com/mcp/quickstart.md',
});
